<template>
  <template v-if="empty">
    <a
      :class="
        `d-flex justify-content-between align-items-center ` +
        (compareValues($route.name, item.name) ? 'active' : '')
      "
      href="#"
      @click.prevent="$emit('open')"
    >
      <span>
        <i
          v-if="icon"
          class="bi"
          :class="icon"
        ></i>
        {{ item.meta.titleKey ? t(item.meta.titleKey) : item.meta.title }}
      </span>
      <i
        v-if="icon"
        class="bi bi-caret-down-fill"
      ></i>
    </a>
  </template>
  <template v-else>
    <RouterLink
      :to="{ name: item.name }"
      :class="{ active: compareValues($route.name, item.name) }"
    >
      <i
        v-if="icon"
        class="bi"
        :class="icon"
      ></i>
      {{ item.meta.titleKey ? t(item.meta.titleKey) : item.meta.title }}
    </RouterLink>
  </template>
</template>
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  item: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  empty: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['open'])
const icon = computed(() => (props.item.meta.icon ? `bi-${props.item.meta.icon}` : null))

const compareValues = (url, name) => {
  if (typeof url !== 'string' || typeof name !== 'string') {
    return false
  }
  if (url === name) {
    return true
  }
  if (name === 'users.list') {
    return url === 'users.item'
  }
  if (name === 'users.updating') {
    return false
  }
  let regex = /^\w+\.\w+\./
  if (name.split('.').length === 2) {
    regex = /^\w+/
  }
  const match1 = url.match(regex)
  const match2 = name.match(regex)
  if (match1 && match2) {
    return match1[0] === match2[0]
  }
  return false
}
</script>
